export type FeedbackVariants =
  | 'feedback-positive'
  | 'feedback-negative'
  | 'feedback-notice'
  | 'feedback-neutral'
  | 'feedback-pending'
  | 'feedback-informational'
  | 'feedback-staff'
  | 'feedback-loading';

export type EquityVariants =
  | 'equity-common'
  | 'equity-preferred'
  | 'equity-convertible'
  | 'equity-warrant'
  | 'equity-option'
  | 'equity-pool';

export type GlobalVariants = EquityVariants | FeedbackVariants;

export const ornamentVariantColors = [
  'white',
  'blue',
  'brown',
  'yellow',
  'gray',
  'orange',
  'green',
  'red',
  'gray-darker',
  'blue-lightest',
  'blue-light',
  'green-lightest',
  'slate',
] as const;

export type OrnamentVariantColorTypes = typeof ornamentVariantColors[number];

/* Ideally these will be mapped and renamed into the global variants above */
export type LegacyVariants =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'setup'
  | 'staff'
  | 'upload'
  | 'download'
  | 'generating';
